import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // routes: [
  //   {
  //     path: '/',
  //     name: 'home',
  //     component: () => h('div', { class: 'flex items-center justify-center h-screen' }, []),
  //   },
  //   {
  //     path: '/bank-integration/:bankIntegrationConsentID',
  //     name: 'bank-integration',
  //     meta: {
  //       hideNavbar: true,
  //       unauthenticatedAccess: true,
  //     },
  //     component: () => import('../views/BankIntegration/BankIntegrationView.vue'),
  //   },
  // ],
  routes,
})

if (import.meta.hot) {
  handleHotUpdate(router)
}

// router.beforeEach((to, from, next) => {
//   // First change the title of the page
//   document.title = (to.meta.title as string) ?? 'Bucky Merchant Portal'
//   if (!PejerBase.hasCookie(config.cookieNames.platformToken) && !to.meta.unauthenticatedAccess) {
//     next({ name: 'login', query: { errorCode: '401' } })
//   } else next()
// })

export default router
